/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';

const template = html`
        <style include="app-styles">
        .stepupauthbtn{
			background-color:transparent;
		}
		</style>
        <div class="mdl-grid --no-spacing">
			<fin-auth-element-wrapper otp-link={{otpLink}} isvalid="{{isvalid}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet margin-b-zero padding-b-zero" id="authWrapperStepUp" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
			<paper-button class="stepupauthbtn mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop mdl-cell--8-col-tablet padding-t-zero margin-t-zero" id="stepUpSubmit" on-tap="submit">
                    <oe-i18n-msg msgid="b_Submit"></oe-i18n-msg>
			</paper-button>
        </div>`;
   
        Polymer({
            is: "stepup-auth",
            _template:template,
            properties: {
                header: {
                    type: Object
                },
                authMethods: {
                    type: Object,
                    notify: true
                },
				isvalid:{
					type:Boolean,
					value:false,
					notify:true,
					observer:'_isValidChanged'
                },
                //property for showing resend button for OTP.
                otpLink: {
                    type: Boolean,
                    notify: true,
                    value: false
				}
            },
            _isValidChanged: function () {
                if (this.$.stepUpSubmit) {
                    this.$.stepUpSubmit.disabled = !this.isvalid;
                    this.$.stepUpSubmit.toggleClass("text-brand-color", this.isvalid);
                }
            },
            submit: function () {
				this.fire('setUpAuth',{authMethod:this.authMethods});
            }
        });
